export default __webpack_public_path__ + "static/media/nurse2.7168318c.svg";